import { type AutocompleteProps } from '@mui/material'

import { SearchField } from 'components/common/SearchField'
import { VirtualizedListboxComponent } from 'components/common/VirtualizedListboxComponent'
import { KubernetesAutocompleteSearchOption } from 'components/services/create/target-selection/kubernetes/KubernetesAutocompleteSearchOption'

import type { K8sAutocompleteSearchOption } from 'components/services/create/target-selection/kubernetes/types'

export function getCommonK8sObjectsAutocompleteProps<TMultiple extends boolean>(
  hasSelectedOptions?: boolean
): Omit<
  AutocompleteProps<K8sAutocompleteSearchOption, TMultiple, false, false>,
  'options'
> & {
  ListboxProps: {
    OptionComponent: typeof KubernetesAutocompleteSearchOption
  }
} {
  return {
    clearOnBlur: false,
    disableListWrap: true,
    filterSelectedOptions: true,
    isOptionEqualToValue: (option, value) => option.uid === value.uid,
    ListboxComponent: VirtualizedListboxComponent,
    ListboxProps: {
      OptionComponent: KubernetesAutocompleteSearchOption
    },
    popupIcon: null,
    renderGroup: (params) => params,
    renderInput: (params) => (
      <SearchField
        {...params}
        {...(!hasSelectedOptions && {
          placeholder: 'Narrow the number of potential targets by name'
        })}
        label="Targets"
      />
    ),
    renderOption: (props, option) => [props, option],
    slotProps: { paper: { elevation: 8 } }
  }
}
